import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "@fontsource-variable/anybody/standard.css";
import "@fontsource-variable/hanken-grotesk";
import { App } from "./App.js";
import { AppProviders } from "./app/providers.js";
import { captureLinkFragment, linkStorage } from "./lib/extensionLink.js";
import "./styles.css";

function getRoot(): HTMLElement {
  const el = document.getElementById("root");
  if (el === null) {
    throw new Error("Missing #root element.");
  }
  return el;
}

// Extension link: move the request out of the URL before anything (router, sign-in) sees it.
captureLinkFragment(window, linkStorage(), Date.now());

createRoot(getRoot()).render(
  <StrictMode>
    <AppProviders>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>
);
